import type { IconProps } from './base';
import { BaseIcon } from './base';

export function IconFlagNO(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <mask id="icon-flag-no" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" rx="12" fill="#C4C4C4" />
      </mask>
      <g mask="url(#icon-flag-no)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 2C0 0.89543 0.895431 0 2 0H22C23.1046 0 24 0.895431 24 2V22C24 23.1046 23.1046 24 22 24H2C0.89543 24 0 23.1046 0 22V2Z"
          fill="#BA0C2F"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10 10V0H14V10H24V14H14V24H10V14H0V10H10Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11 11V0H13V11H24V13H13V24H11V13H0V11H11Z"
          fill="#00205B"
        />
        <circle cx="12" cy="12" r="11.5" stroke="#3C3C60" strokeOpacity="0.1" />
      </g>
    </BaseIcon>
  );
}
